import { cn } from "@/lib/cn";

interface FabricTypeSelectorProps<T extends string> {
    options: T[];
    labels: Record<T, string>;
    value: T;
    onChange: (value: T) => void;
    title?: string;
}

export function FabricTypeSelector<T extends string>({
    options,
    labels,
    value,
    onChange,
    className,
    title,
}: FabricTypeSelectorProps<T> & { className?: string }) {
    return (
        <div className={cn("flex flex-col flex-basis-0 grow gap-2", className)}>
            {title && (
                <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">
                    {title}
                </p>
            )}
            <div className="flex flex-row gap-2">
                {options.map((option) => (
                    <button
                        key={option}
                        type="button"
                        data-testid={`fabric-type-btn-${option.toLowerCase().replace("_", "-")}`}
                        onClick={() => onChange(option)}
                        className={cn(
                            "rounded-lg border px-3 py-1.5 text-xs font-medium transition-colors cursor-pointer",
                            value === option
                                ? "border-primary bg-primary text-white"
                                : "border-gray-300 text-gray-600 hover:border-gray-400",
                        )}
                    >
                        {labels[option]}
                    </button>
                ))}
            </div>
        </div>
    );
}
